import { Modal } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'

type Data = {
  showModal: boolean,
  children: ReactElement

  closable?: boolean
  closeByOutsideClick?: boolean
  bodyBackground?: string
  maskBackground?: string
  wrapClassName?: string
  width?: string
  afterClose?: () => void
}


export default function InfoModal({
  closable: closableProp = false,
  closeByOutsideClick: closeByOutsideClickProp = false,
  bodyBackground: bodyBackgroundProp = '#FFF',
  maskBackground: maskBackgroundProp = 'rgba(0, 0, 0, 0.5)',
  wrapClassName: wrapClassNameProp = '',
  width: widthProp = '680px',
  ...props
}: Data): ReactElement {

  const [open, setOpen] = useState<boolean>()

  useEffect(() => {
    setOpen(props.showModal)
  }, [props.showModal])

  return (
    <Modal
      open={open}
      closable={closableProp}
      maskClosable={closeByOutsideClickProp}
      onCancel={() => setOpen(false)}
      afterClose={props.afterClose}
      zIndex={10003}
      footer={false}
      centered
      bodyStyle={{
        position: 'absolute',
        width: widthProp,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px 0',
        background: bodyBackgroundProp,
        borderRadius: '30px',
        outline: 'none',
        textAlign: 'center'
      }}
      maskStyle={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        background: maskBackgroundProp,
        backdropFilter: 'blur(8px)'
      }}
      wrapClassName={wrapClassNameProp}>
      {props.children}
    </Modal>
  )
}
